import {
    DependenciesPayload,
    Subscription,
} from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getSubscriptionsAll(
    dependencies: DependenciesPayload,
): Promise<Subscription[]> {
    const { clientSdk } = dependencies;

    const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
        Awaited<
            ReturnType<typeof clientSdk.commerce.subscription.getSubscriptions>
        >,
        Subscription[]
    > = (subscriptions) => {
        return subscriptions.map((subscription) => ({
            ...subscription,
            beneficiaries: (subscription as any).beneficiaries,
            billingProfileId: subscription.billingProfileId || '',
            currentPhase: {
                billingPeriod: {
                    ...('days' in subscription.currentPhase.billingPeriod
                        ? {
                              days: {
                                  ...subscription.currentPhase.billingPeriod
                                      .days,
                              },
                          }
                        : { days: { count: 0 } }),
                    ...('weeks' in subscription.currentPhase.billingPeriod
                        ? {
                              weeks: {
                                  ...subscription.currentPhase.billingPeriod
                                      .weeks,
                              },
                          }
                        : { weeks: { count: 0 } }),
                    ...('months' in subscription.currentPhase.billingPeriod
                        ? {
                              months: {
                                  ...subscription.currentPhase.billingPeriod
                                      .months,
                              },
                          }
                        : { months: { count: 0 } }),
                    ...('years' in subscription.currentPhase.billingPeriod
                        ? {
                              years: {
                                  ...subscription.currentPhase.billingPeriod
                                      .years,
                              },
                          }
                        : { years: { count: 0 } }),
                },
                billingPeriodCount:
                    subscription.currentPhase.billingPeriodCount || 0,
                ends: subscription.currentPhase.ends || '',
                started: subscription.currentPhase.started || '',
                type: subscription.currentPhase.type,
            },
            expires: subscription.expires || '',
            offerPhases: (subscription as any).offerPhases,
            offers: (subscription as any).offers,
            started: subscription.started || '',
            terminated: subscription.terminated || '',
            detailedState: null,
            offerPromo: null,
            offerSelfPay: null,
            offerTrial: null,
        }));
    };

    const subscriptions = mapClientSdkToWebSdk(
        await clientSdk.commerce.subscription.getSubscriptions(),
    );
    return subscriptions;
}
